<template>
  <div class="landingSection3">
    <landing-container>
      <h3 class="landingSection3__title" v-html="title" />
      <div class="landingSection3__dividerWrapper">
        <divider />
      </div>

      <div class="landingSection3__steps steps">
        <div class="steps__item" v-for="(step, index) in steps" :key="index">
          <span>
            <img :src="require(`img/landing/${step.icon}.png`)" />
          </span>
          <p class="steps__text">{{ step.text }}</p>
        </div>
      </div>

      <div class="landingSection3__btnWrapper">
        <a
          :href="toRegistration"
          target="_blank"
          class="landingSection3__btn btnFarm btnFarm--primary btnFarm--lg btnWrapper__btn"
        >
          {{ $t("Sign up") }}
        </a>
      </div>
    </landing-container>
  </div>
</template>

<script>
import LandingContainer from "@/components/Landing/components/LandingContainer.vue";
import Divider from "@/components/Landing/components/Divider.vue";
import { toRegistration } from "@/tools";

export default {
  name: "LandingSection3",
  components: { LandingContainer, Divider },
  data() {
    return {
      selectTags: {
        selectStart: '<span class="textW--primary">',
        selectEnd: "</span>",
      },
    };
  },
  computed: {
    toRegistration,
    steps() {
      return [
        { icon: "step-1", text: this.$t("Register on the website") },
        { icon: "step-2", text: this.$t("Download mobile application Ultima Wallet") },
        { icon: "step-3", text: this.$t("Create your wallet") },
        {
          icon: "step-4",
          text: this.$t("Enjoy the full advantages of the PLCU technology"),
        },
      ];
    },
    title() {
      return this.$t(
        `It’s easy to become a PLC {selectStart}Ultima{selectEnd} user:`,
        this.selectTags
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.landingSection3 {
  padding: 64px 0;

  background: #f6f6f7 url("~img/landing/earth-bg.png") top center no-repeat;

  @media (min-width: $breakpoint-md) {
    background: #f6f6f7 url("~img/landing/earth-bg.png") center no-repeat;
  }

  @media (min-width: $breakpoint-xl) {
    padding: 96px 0;
  }

  &__title {
    color: #1c1c1e;
    font-family: $font-secondary;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;

    @media (min-width: $breakpoint-xl) {
      font-size: 28px;
      line-height: 36px;
    }
  }

  &__dividerWrapper {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }

  &__btnWrapper {
    display: flex;
    justify-content: center;
    margin-top: 48px;

    @media (min-width: $breakpoint-xl) {
      margin-top: 64px;
    }
  }

  &__btn {
    width: 100%;

    @media (min-width: $breakpoint-md) {
      max-width: 268px;
    }
  }
}
.steps {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  margin-top: 48px;

  @media (min-width: $breakpoint-md) {
    flex-direction: row;
    align-items: flex-start;
  }

  @media (min-width: $breakpoint-xl) {
    max-width: 1092px;
    margin: 64px auto;
  }

  &__item {
    --circle-size: 96px;
    --spacing: 16px;

    position: relative;
    flex: 1;
    text-align: center;
    flex-direction: column;

    &:not(:first-child) {
      margin-top: 32px;
    }

    @media (min-width: $breakpoint-md) {
      &:not(:first-child) {
        margin-top: 0;
      }

      &:not(:last-child) {
        &:after {
          content: "";
          position: absolute;
          top: calc(var(--circle-size) / 2);
          width: calc(100% - var(--circle-size) - calc(var(--spacing) * 2));
          left: calc(50% + calc(var(--circle-size) / 2 + var(--spacing)));
          height: 2px;
          border-top: #81a9e9 2px dashed;
          order: -1;
          box-sizing: border-box;
        }
      }
    }
    @media (min-width: $breakpoint-xl) {
      --spacing: 32px;
    }
  }

  &__text {
    font-family: $font-secondary;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.87);
    margin-top: 24px;

    @media (min-width: $breakpoint-xl) {
      font-size: 16px;
      margin-top: 32px;
    }
  }
}

img {
  max-width: 96px;
}
</style>
